import { Component, OnInit, Input } from '@angular/core';
import { DocumentaryService } from 'src/app/services/documentary.service';
import { GlobalService } from 'src/app/services/global.service';
import { UploadfileComponent } from 'src/app/popup/uploadfile/uploadfile.component'
import { FormGroup, FormBuilder } from '@angular/forms';
import { faPlus, faFolderOpen as fafolderopen, faUser } from '@fortawesome/free-solid-svg-icons';
import { faFile, faFolderOpen, faUserCircle } from '@fortawesome/free-regular-svg-icons';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NewfolderComponent } from '../../popup/newfolder/newfolder.component';
import { ChangeNameFolderComponent } from '../../popup/change-name-folder/change-name-folder.component';

@Component({
  selector: 'app-easydoc',
  templateUrl: './easydoc.component.html',
  styleUrls: ['./easydoc.component.css']
})
export class EasydocComponent implements OnInit {

  @Input() folder_id;

  token: string;

  selectedDir: any;

  parentID: Array<any> = [];
  menu: Array<any> = [];
  navigationArray: Array<any> = [];

  backDir: string;
  // boolean
  show = false;
  enterIf = false;
  disable = false;
  double = false;

  // number
  i = 1;

  // formData
  formData: any;
  uploadForm: FormGroup;

  // Icone
  faPlus = faPlus;
  faFile = faFile;
  faFolderOpen = faFolderOpen;
  faUserCircle = faUserCircle;
  fafolderopen = fafolderopen;
  faUser = faUser;

  folderIdActive: string;

  constructor(
    private documentaryService: DocumentaryService,
    private globals: GlobalService,
    private formBuilder: FormBuilder,
    public activeModal: NgbActiveModal,
    private modalService: NgbModal,
  ) { }

  ngOnInit() {
    if (!this.token) {
      this.token = this.globals.getToken();
    }
    this.getFolderContent(this.folder_id);
    this.uploadForm = this.formBuilder.group({
      profile: ['']
    });
    this.formData = new FormData();
  }

  getFolderContent(folderId) {
    this.documentaryService.getFolderContent(this.token, folderId).subscribe(
      res => {
        this.folderIdActive = folderId;
        this.selectedDir = res.list;
        this.backDir = res.list[0].entry.parentId;
        if (folderId == this.folder_id) {
          this.show = false;
        } else {
          this.show = true;
        }
        this.disable = false;
      },
      err => {
        console.error("Errore in openFolder: ", err);
        this.disable = false;
      }
    )
  }

  backFolder() {
    this.documentaryService.getFolderContent(this.token, this.backDir).subscribe(
      res => {
        this.folderIdActive = this.backDir;
        this.selectedDir = res.list;
        if (this.backDir == this.folder_id) {
          this.show = false;
        } else {
          this.show = true
        }
        this.backDir = res.parentId;
        this.disable = false;
        this.changeLastModify(this.selectedDir);
        this.changeDimension(this.selectedDir);
        this.changeCreateAt(this.selectedDir);
      },
      err => {
        console.error("Errore in openFolder: ", err);
        this.disable = false;
      }
    )
  }

  uploadFile() {
    const modalRef = this.modalService.open(UploadfileComponent, { backdrop: 'static', centered: true, size: 'xl' });
    modalRef.componentInstance.id = this.folderIdActive
    modalRef.result.then((result) => {
      if (result != 'cancel') {
        this.documentaryService.getFolderContent(this.token, this.folderIdActive).subscribe(
          res => {
            this.selectedDir = res.list;
            this.changeLastModify(this.selectedDir);
            this.changeDimension(this.selectedDir);
            this.changeCreateAt(this.selectedDir);
          },
          err => {
            console.error("Errore in getFolderContent: ", err);
          })
      }
    })
  }

  openFolder(file) {
    this.disable = true;
    this.backDir = file.parentId;
    if (file == "home") {
      this.getFolderContent(this.folder_id);
    } else {
      this.documentaryService.getFolderContent(this.token, file.id).subscribe(
        res => {
          this.folderIdActive = file.id;
          this.selectedDir = res.list;
          if (file.id == this.folder_id) {
            this.show = false;
          } else {
            this.show = true
          }
          this.disable = false;
          this.changeLastModify(this.selectedDir);
          this.changeDimension(this.selectedDir);
          this.changeCreateAt(this.selectedDir);
        },
        err => {
          console.error("Errore in openFolder: ", err);
          this.disable = false;
        }
      )
    }
  }

  newFolder(name) {

    const modalRef = this.modalService.open(NewfolderComponent, { backdrop: 'static', centered: true, size: 'xl' });
    modalRef.componentInstance.folderName = name;
    modalRef.componentInstance.folderID = this.folderIdActive; // folder_id
    modalRef.result.then(result => {
      if (result != 'cancel') {
        this.documentaryService.getFolderContent(this.token, this.folderIdActive).subscribe(
          res => {
            this.selectedDir = res.list;
            this.changeLastModify(this.selectedDir);
            this.changeDimension(this.selectedDir);
            this.changeCreateAt(this.selectedDir);
          },
          err => {
            console.error("Errore in getFolderContent: ", err);
          }
        )
      }
    }, reason => {
    }
    );
  }

  delFolder(file) {
    this.documentaryService.delFolder(this.token, file.id).subscribe(
      res => {
        this.documentaryService.getFolderContent(this.token, this.folderIdActive).subscribe(
          res => {
            this.selectedDir = res.list;
            this.changeLastModify(this.selectedDir);
            this.changeDimension(this.selectedDir);
            this.changeCreateAt(this.selectedDir);
          },
          err => {
            console.error("Errore in openFolder: ", err);
            this.disable = false;
          }
        )
      },
      err => {
        console.error("Errore: ", err);

      }
    )
  }

  openPopup(file) {
    const modalRef = this.modalService.open(ChangeNameFolderComponent, { backdrop: 'static', centered: true, size: 'xl' });
    modalRef.componentInstance.id = file.id;
    modalRef.componentInstance.folderName = file.name;
    modalRef.result.then(result => {
      if (result != 'Cancel') {
        this.documentaryService.getFolderContent(this.token, this.folderIdActive).subscribe(
          res => {
            this.selectedDir = res.list;
            this.changeLastModify(this.selectedDir);
            this.changeDimension(this.selectedDir);
            this.changeCreateAt(this.selectedDir);
          },
          err => {
            console.error("Errore in openFolder: ", err);
            this.disable = false;
          }
        )
      }
    })
  }

  changeLastModify(file) {
    file.forEach((fil) => {
      if (fil.entry.isFile == true) {
        let date = new Date(fil.entry.modifiedAt);
        if (date.getMonth() + 1 > 10 && date.getDate() >= 10) {
          fil.entry.modifiedAt = '' + (date.getDate()) + '/' + (date.getMonth() + 1) + '/' + date.getFullYear();
          // console.log("mese e giorno >10")
        } else {

          if (date.getMonth() + 1 < 10 && date.getDate() < 10) {
            fil.entry.modifiedAt = '' + (date.getDate()) + '/' + '0' + (date.getMonth() + 1) + '/' + '0' + date.getFullYear();
            // console.log("mese e giorno <10")
          } else {

            if (date.getMonth() + 1 < 10) {
              fil.entry.modifiedAt = '' + (date.getDate()) + '/' + '0' + (date.getMonth() + 1) + '/' + date.getFullYear();
              // console.log("mese <10")
            }

            if (date.getDate() < 10) {
              fil.entry.modifiedAt = '' + (date.getDate()) + '/' + (date.getMonth() + 1) + '/' + '0' + date.getFullYear();
              // console.log("giorno <10")
            }
          }
        }
      }
    })
  }

  changeDimension(byte) {
    byte.forEach(byt => {
      if (byt.entry.isFile == true) {
        if (byt.entry.content.sizeInBytes < 1024) {
          Math.round(parseInt(byt.entry.content.sizeInBytes))
          byt.entry.content.sizeInBytes = byt.entry.content.sizeInBytes + " Byte";
        } else {
          if (byt.entry.content.sizeInBytes >= 1073741824) {
            byt.entry.content.sizeInBytes = byt.entry.content.sizeInBytes / 1073741824;
            byt.entry.content.sizeInBytes = Math.round(parseInt(byt.entry.content.sizeInBytes));
            byt.entry.content.sizeInBytes = byt.entry.content.sizeInBytes + " GB"
          } else {
            if (byt.entry.content.sizeInBytes >= 1048576) {
              byt.entry.content.sizeInBytes = byt.entry.content.sizeInBytes / 1048576;
              byt.entry.content.sizeInBytes = Math.round(parseInt(byt.entry.content.sizeInBytes));
              byt.entry.content.sizeInBytes = byt.entry.content.sizeInBytes + " MB"
            } else {
              if (byt.entry.content.sizeInBytes >= 1024) {
                byt.entry.content.sizeInBytes = byt.entry.content.sizeInBytes / 1024;
                byt.entry.content.sizeInBytes = Math.round(parseInt(byt.entry.content.sizeInBytes));
                byt.entry.content.sizeInBytes = byt.entry.content.sizeInBytes + " KB"
              }
            }
          }
        }
      }
    });
  }

  changeCreateAt(file) {

    file.forEach((fil) => {
      if (fil.entry.isFile == true) {
        let date = new Date(fil.entry.createdAt);
        if (date.getMonth() + 1 > 10 && date.getDate() >= 10) {
          fil.entry.createdAt = '' + (date.getDate()) + '/' + (date.getMonth() + 1) + '/' + date.getFullYear();
          // console.log("mese e giorno >10")
        } else {

          if (date.getMonth() + 1 < 10 && date.getDate() < 10) {
            fil.entry.createdAt = '' + (date.getDate()) + '/' + '0' + (date.getMonth() + 1) + '/' + '0' + date.getFullYear();
            // console.log("mese e giorno <10")
          } else {

            if (date.getMonth() + 1 < 10) {
              fil.entry.createdAt = '' + (date.getDate()) + '/' + '0' + (date.getMonth() + 1) + '/' + date.getFullYear();
              // console.log("mese <10")
            }

            if (date.getDate() < 10) {
              fil.entry.createdAt = '' + (date.getDate()) + '/' + (date.getMonth() + 1) + '/' + '0' + date.getFullYear();
              // console.log("giorno <10")
            }
          }
        }
      }
    })
  }

}
